module.exports = __webpack_public_path__ + "static/mockup-frame-b9050674e8edc6198f7f43b91c8db7a6.png";